module.exports = __webpack_public_path__ + "img/10.0b43b026.jpg";